<script>
    import vSelect from 'vue-select';
    import HomeCourseCard from '../home/HomeCourseCard';
    import {Form} from '../../helpers/Form/Form'

    export default {
        components: {
            HomeCourseCard,
            'v-select': vSelect
        },
        name: 'landing-show',
        props: [
            'landing_prop',
            'tags_prop',
        ],
        data() {
            return {
                orangopacks_count: 0,
                courses_count: 0,
                companies_count: 0,
                events_count: 0,
                landing: {},
                company_settings: {},
                course_settings: {},
                orangopack_settings: {},
                event_settings: {},
                tags: [],
                companies: [],
                companies_pagination: {},
                courses: [],
                courses_pagination: {},
                events: [],
                events_pagination: {},
                orangopacks: [],
                orangopacks_pagination: {},                
                courses_by_distance: [],
                offset_companies: 8,
                offset_courses: 8,
                offset_orangopacks: 8,
                offset_events: 8,
                companies_count: 0,
                city_search: null,
                coords: [],
                imageBackground: null,
                is_geolocalized: false,
                municipalities: [],
                form: new Form({
                    id: null,
                    municipality: null,
                    promoted: false,
                    per_page: 8,
                    page: 1,
                    latitude: 0,
                    longitude: 0
                })
            }
        },
        computed: {
            landingStyle() {
                return {
                    backgroundImage: `url('${this.getBackgroundImage()}')`
                }
            }
        },
        mounted() {
            var self = this;
            this.landing = this.landing_prop;
            this.tags = this.tags_prop;
            if (this.landing.settings.hasOwnProperty('company')) {
                this.company_settings = this.landing.settings.company;
            }
            if (this.landing.settings.hasOwnProperty('course')) {
                this.course_settings = this.landing.settings.course;
            }
            if (this.landing.settings.hasOwnProperty('orangopack')) {
                this.orangopack_settings = this.landing.settings.orangopack;
            }
            if (this.landing.settings.hasOwnProperty('event')) {
                this.event_settings = this.landing.settings.event;
            }

            this.fetchData()
            this.getLocation()

            window.addEventListener('resize', () => {
                this.getBackgroundImage()
            });            
        },
        methods: {
            getBackgroundImage() {
                if (window.isMobile()) {
                    if (this.landing.image_path_mobile) {
                        return this.landing.image_mobile_full_url
                    }
                    return this.landing.image_full_url
                }

                return this.landing.image_full_url
            },
            async fetchData() {
                await this.fetchMunicipalities()
                await this.fetchCompanies()
                await this.fetchEvents()
                await this.fetchCourses()
                await this.fetchCourses(true)
            },
            async onFilters() {
                this.$set(this, 'companies', [])
                this.$set(this, 'courses', [])
                this.$set(this, 'orangopacks', [])
                this.$set(this, 'events', [])
                this.$set(this, 'companies_pagination', {})
                this.$set(this, 'courses_pagination', {})
                this.$set(this, 'orangopacks_pagination', {})
                this.$set(this, 'events_pagination', {})                

                await this.fetchCompanies()
                await this.fetchEvents()
                await this.fetchCourses()
                await this.fetchCourses(true)
            },
            loadMoreCompanies() {
                this.$set(this.form, 'page', this.companies_pagination.current_page + 1)    

                this.fetchCompanies()
            },
            loadMoreCourses() {
                this.$set(this.form, 'page', this.courses_pagination.current_page + 1)    

                this.fetchCourses()
            },
            loadMoreOrangopacks() {
                this.$set(this.form, 'page', this.orangopacks_pagination.current_page + 1)    

                this.fetchCourses(true)
            },
            loadMoreEvents() {
                this.$set(this.form, 'page', this.events_pagination.current_page + 1)  

                this.fetchEvents()
            },
            courseHref(course) {
                return '/corsi/' + course.slug;
            },
            async fetchCompanies() {
                if (this.company_settings && this.company_settings.hasOwnProperty('elements')) {
                    this.$set(this.form, 'per_page', this.company_settings.elements.value)
                }

                await this.form
                    .get(route('landings.companies', this.landing.slug))
                    .then(response => {
                        this.$set(this, 'companies', this.companies.concat(response.companies.data));
                        this.$set(this, 'companies_pagination', _.omit(response.companies, 'data'))
                    })
            },
            async fetchEvents() {
                if (this.event_settings && this.event_settings.hasOwnProperty('elements')) {
                    this.$set(this.form, 'per_page', this.event_settings.elements.value)
                }

                await this.form
                    .get(route('landings.events', this.landing.slug))
                    .then(response => {
                        this.$set(this, 'events', this.events.concat(response.events.data));
                        this.$set(this, 'events_pagination', _.omit(response.events, 'data'))                        
                    })
            },      
            async fetchCourses(promoted = false) {
                this.$set(this.form, 'promoted', promoted)

                if (promoted) {
                    if (this.orangopack_settings && this.orangopack_settings.hasOwnProperty('elements')) {
                        if (this.orangopack_settings.elements.value != 'null') {
                            this.$set(this.form, 'per_page', this.orangopack_settings.elements.value)
                        }
                    }
                } else {
                    if (this.course_settings && this.course_settings.hasOwnProperty('elements')) {
                        if (this.course_settings.elements.value != 'null') {
                            this.$set(this.form, 'per_page', this.course_settings.elements.value)
                        }
                    }
                }

                await this.form
                    .get(route('landings.courses', this.landing.slug))
                    .then(response => {
                        if (this.form.promoted) {
                            this.$set(this, 'orangopacks', this.orangopacks.concat(response.courses.data));
                            this.$set(this, 'orangopacks_pagination', _.omit(response.courses, 'data'))                            
                        } else {
                            this.$set(this, 'courses', this.courses.concat(response.courses.data));
                            this.$set(this, 'courses_pagination', _.omit(response.courses, 'data'))      
                        }
                    })
            },                       
            async fetchMunicipalities() {
                await this.form
                    .get(route('landings.municipalities', this.landing.slug))
                    .then(response => {
                        for (let idx in response.municipalities) {
                            this.municipalities.push(response.municipalities[idx])
                        }

                        this.$set(this, 'municipalities', this.municipalities.sort())
                    })
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        this.returnPosition,
                        this.errorPosition
                    );
                }
            },
            async returnPosition(position) {
                this.$set(this.form, 'latitude', position.coords.latitude * 1)
                this.$set(this.form, 'longitude', position.coords.longitude * 1)
            },
            async errorPosition(error) {
                let {latitude, longitude} = this.form
                if (_.isEmpty(latitude) && _.isEmpty(latitude)) {
                    this.$set(this.form, 'latitude', 0)
                    this.$set(this.form, 'longitude', 0)
                }
            },             
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/landings/LandingShow.vue